export default __webpack_public_path__ + "static/financial_statement-0db83ea55149b10b39915fa89de1e712.png";